<template>
  <div>
    <br />
    <vue-good-table
      :columns="headers"
      :rows="filteredMatches"
      theme="nocturnal"
      :sort-options="{
        enabled: true,
        initialSortBy: { field: 'kick_off', type: 'asc' }
      }"
      :search-options="{
        enabled: true
      }"
      :pagination-options="{
        enabled: true,
        perPage: 15
      }"
    >
      <div slot="emptystate">
        <div v-show="isLoading" class="progress-horizontal">
          <div class="bar-horizontal"></div>
        </div>
        <span v-show="!isLoading">
          There are no matches currently. Check back later 😉
        </span>
      </div>
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'id'">
          {{ props.row.bookie === 'flashscore' ? props.row.id : props.row.id.substring(props.row.id.indexOf("_") + 1) }}
        </span>
        <span v-else-if="props.column.field == 'home_team'">
          <span v-if="isMatchChecked(props.row)"
            >{{ props.row.home_team }} vs {{ props.row.away_team }}</span
          >
          <a
            v-else-if="matchUrl(props.row)"
            target="_blank"
            :href="matchUrl(props.row)"
          >
            {{ props.row.home_team }} vs {{ props.row.away_team }}
          </a>
          <span v-else>{{ props.row.home_team }} vs {{ props.row.away_team }}</span>
        </span>
        <span v-else-if="props.column.field == 'kick_off'">
          {{formatDateTime(props.row.kick_off)}}
        </span>
        <span v-else-if="props.column.field == 'created_at'">
          {{formatDateTime(props.row.created_at)}}
        </span>
        <span v-else-if="props.column.field == 'updated_at'">
          {{formatDateTime(props.row.updated_at)}}
        </span>
        <span v-else-if="props.column.field == 'is_checked'">
          <span v-if="isMatchChecked(props.row)">Yes</span>
          <span v-else>
            No
            <base-checkbox
              v-model="props.row.is_checked"
              inline
              style="margin-left: 5px"
              @checked="updateCheckedMatch(props.row.id)"
            />
          </span>
        </span>
        <span v-else-if="props.column.field == 'is_hidden'">
          <span>
            {{ props.row.is_hidden ? "Yes" : "No" }}
            <base-checkbox
              v-model="props.row.is_hidden"
              inline
              style="margin-left: 5px"
              @input="toggleMatchVisibility(props.row.id)"
            />
          </span>
        </span>
        <span v-else-if="props.column.field == 'actions'">
          <button type="button" class="btn btn-primary btn-sm" @click="addAlternativeName(props.row.home_team, props.row.away_team)">
            Add Alternative Name
          </button>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
    <add-alternative-match-dialog :showAddNameModal="showAddNameModal" :form="alternativeNameForm" :formAction="alternativeNameFormAction" :alternative-names="alternative_match_names" @close="showAddNameModal = false; resetForm()" />
  </div>
</template>

<script>
import { BaseCheckbox } from "@/components";
import { mapGetters } from "vuex";
import axios from "axios";
import formatDateTime from "../mixin/formatDateTime";
import AddAlternativeMatchDialog from '@/components/AddAlternativeMatchDialog.vue';

export default {
  name: "match-table",
  mixins: [formatDateTime],
  props: {
    headers: {
      type: Array,
      description: "columns to be displayed in the table"
    },
    category: {
      type: String,
      description: "category of match to be fetched"
    },
    filter: {
      type: String,
      description: "filter to be applied to the matches"
    },
    filter2: {
      type: String,
      description: "filter to be applied to the matches"
    },
    rows: {
      type: Array,
      description: "rows to be displayed in the table"
    },
    bookieBaseUrl: {
      type: String,
      description: "base url for the bookie"
    }
  },
  components: {
    BaseCheckbox,
    AddAlternativeMatchDialog
  },
  data() {
    return {
      isLoading: true,
      isRefreshing: false,
      showAddNameModal: false,
      alternativeNameForm: {
        bookie: '',
        alternative_name: '',
        category: '',
        has_error : false,
        error_message : '',
      },
      alternativeNameFormAction: 'Add',
      alternative_match_names: {
        home_team: '',
        away_team: '',
      },
    };
  },
  mounted() {
    this.alternativeNameForm.bookie = this.selectedBookie.toLowerCase()
    this.alternativeNameForm.category = this.toTitleCase(this.replaceHyphenWithSpaces(this.categoryName))
    if (this.alternativeNameForm.category === 'Hockey') {
      this.alternativeNameForm.category = 'Ice Hockey'
    }
  },
  computed: {
    ...mapGetters(["selectedBookie"]),
    categoryName () {
      return this.$route.name
    },
    filteredMatches() {
      let rows = [];
      if (this.filter === "All") {
        rows = this.rows.filter(row => row.is_checked || !row.is_checked);
      } else if (this.filter === "Checked") {
        rows = this.rows.filter(row => this.isMatchChecked(row));
      } else {
        console.log("Filtering out unchecked matches...");
        rows = this.rows.filter(row => !this.isMatchChecked(row));
      }

      return rows;
    }
  },
  watch: {
    rows() {
      this.isLoading = false;
    },
  },
  methods: {
    matchUrl(row) {
      return row.url || this.generateMatchUrl(row);
    },
    generateMatchUrl(row) {
      // Check if the current bookie is Sofascore
      if (row.bookie === 'sofascore') {
        // Extract required parameters from the match ID
        // Assuming the match ID format is: category_slug_customId_matchId
        const matchId = row.id;
        const category = row.category;
        const slug = row.additional_details.slug;
        const customId = row.additional_details.custom_id;

        return `https://www.sofascore.com/${category}/match/${slug}/${customId}#id:${matchId}`;
      }
      if (row.bookie === '1xbet') {
        const matchId = row.id;
        const category = row.category;
        const match_slug = row.additional_details.match_slug;
        const league_id = row.additional_details.league_id;
        const league_name_slug = row.additional_details.league_name_slug;

        return `https://1xbet.com/en/line/${category}/${league_id}-${league_name_slug}/${matchId}-${match_slug}`;
      }

      if (row.bookie === 'kwikbet') {
        const matchId = row.id.includes('_') ? row.id.split('_')[1] : row.id;
        const categorySlug = row.additional_details.category_slug || 'unknown-category';
        const leagueSlug = row.additional_details.league_slug || 'unknown-league';
        const matchSlug = row.additional_details.match_slug || 'unknown-match';
        const formattedMatchId = `sm-${matchId}`;

        return `https://www.kwikbet.co.ke/#/${categorySlug}/${leagueSlug}/${matchSlug}/${formattedMatchId}`;
      }

      if (row.bookie === 'betlion') {
        const matchId = row.id.includes('_') ? row.id.split('_')[1] : row.id;
        const sportId = row.additional_details.sport_id || '0';
        const categoryId = row.additional_details.category_id || '0';
        const tournamentId = row.additional_details.tournament_id || '0';

        return `https://betlion.ke/bets/match/pre-match/${sportId}/${categoryId}/${tournamentId}/${matchId}`;
      }

      if (row.bookie === 'wezabet') {
        return null;
      }

      if (row.bookie === 'sportradar') {
        return null;
      }

      if (row.bookie === 'hakibets') {
        const matchId = row.id.includes('_') ? row.id.split('_')[1] : row.id;
        const sportName = (row.additional_details.sport_name || 'soccer').toLowerCase();
        const countryName = (row.additional_details.country_name || '').toLowerCase();
        const competitionName = (row.additional_details.competition_name || '')
          .toLowerCase()
          .replace(/\s+/g, '-');
        const homeTeam = row.home_team.toLowerCase().replace(/\s+/g, '-');
        const awayTeam = row.away_team.toLowerCase().replace(/\s+/g, '-');

        return `https://hakibets.com/sports/${sportName}/${countryName}/${competitionName}/${homeTeam}-vs-${awayTeam}-${matchId}`;
      }

      // For other bookies, use the existing logic
      return this.bookieBaseUrl + (row.id.includes('_') ? row.id.split('_')[1] : row.id);
    },
    isMatchChecked(row) {
      return row.is_checked || (
        row.searched_providers &&
        row.searched_providers.length > 0 &&
        !(row.searched_providers.length === 1 && row.searched_providers[0] === '1xbet')
      )
    },
    updateCheckedMatch(id) {
      console.log("🚀 ~ file: MatchTable.vue:233 ~ updateCheckedMatch ~ id", id)
      // Make a request for rows
      axios
        .post(`/matches/mark-checked/${id}`)
        .then(response => {
          // handle success
          this.refreshMatches();
        })
        .catch(error => {
          // handle error
          console.log(error);
          this.isRefreshing = false;
        });
    },
    toggleMatchVisibility(id) {
      // Make a request for rows
      axios
        .post("/matches/toggle-visibility/" + id)
        .then(response => {
          // handle success
          this.refreshMatches();
        })
        .catch(error => {
          // handle error
          console.log(error);
          this.isRefreshing = false;
        });
    },
    addAlternativeName(home_team, away_team) {
      this.alternative_match_names.home_team = home_team
      this.alternative_match_names.away_team = away_team
      this.showAddNameModal = true;
      this.alternativeNameFormAction = 'Add'
    },
    toTitleCase(str) {
        return str.toLowerCase().split(" ").map(function(word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
        }).join(" ");
    },
    replaceHyphenWithSpaces(string) {
        return string.split("-").join(" ");
    },
    resetForm() {
      this.alternative_match_names = {
        home_team: '',
        away_team: '',
      }
      this.alternativeNameForm.alternative_name = ''
      this.alternativeNameForm.has_error = false
      this.alternativeNameForm.error_message = ''
    },
  },
};
</script>
